<template>
  <main>
    <div  class="breadcumb-area bg-img">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12 col-md-6 p-4">
                    <div class="breadcumb-text">
                        <h5>Iglesia La Senda Antigua</h5>
                        <h2>Fundamentos Cristianos</h2>
                        <p>
                          Nuestro deseo es poder responder al Señor, atender a su instrucción de mirar atentamente a los caminos de nuestros antepasados y 
                          preguntar en la historia cristiana, cuál es el Camino de Dios y seguirlo. 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <h2 v-if="isLoading" class="text-center m-5" > cargando..</h2>
    <div class="container mt-4" v-if="!isLoading">
        <div class="latest-sermons mb-100">
            <div class="row mb-3 mt-3">
                <div class="col-lg-6 col-md-12 contact-form-area">
                    <input v-model="searchText" type="search" class="form-control" id="search"
                            placeholder="buscar sermón por título o predicador" @input="isTyping=true" @keydown.enter="search()">
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 single-sermons" v-for="(sermon, i) in sermons" :key="i" >
                    <div class="sermons-content align-items-center">                        
                        <div :style="`background-image:url(${sermon.cover || 'https://img.youtube.com/vi/r8daNVP4V4U/0.jpg'})`"
                            style="widht:100%; height:15rem;                                      
                                    background-size:100% auto; 
                                    background-repeat:no-repeat; background-position: center;
                                    background-color:#111"
                            />
                        <h1></h1>
                        <!-- Sermons Content -->
                        <div class="sermons-text">
                            <a :href="sermon.videopath" target="_blank">
                                <h6 style="height:2.5rem; overflow: hidden;text-overflow: ellipsis">
                                  {{sermon.title}}
                                  
                                </h6>
                            </a>
                            <p>{{sermon.preacherName}}</p>
                            <p class="date" v-if="sermon.date">{{sermon.date.substr(0,10)}}</p>

                            <div class="row">
                                <div class="col">
                                    <a :href="sermon.videopath" v-if="sermon.videopath!='no asignado'" target="_blank">
                                        video <i class="fa fa-play" aria-hidden="true"></i>
                                    </a>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="all-events-btn mt-2" v-if="sermons.length > 6">
                <button class="btn faith-btn active" @click="showMore()" v-if="searchText===''">Ver Más</button>
            </div>

        </div>        
    </div>


  </main>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      sermons: [],
      allSermons: [],
      isLoading: true,

      documents: [],
      searchText: "",
      isTyping:false,
    };
  },
  mounted() {
    this.getData();
    this.getAllSermons();
  },

  watch:{
    searchText: _.debounce(function(val){
      this.isTyping = false
      // if (val==="") {
      //   this.search()
      // }
    }, 1000),

    isTyping: function(value) {
      if (!value) {
        this.search()
      }
    }
  },

  methods: {
    async getData() {
      try {        
        this.isLoading = true;
        const url = this.$store.state.url + "api/lessons/last";
        const req = await fetch(url);
        this.sermons = await req.json();                
        this.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    
    showMore() {
      let n = this.sermons.length;
      for (let i = 0; i < 6; i++) {
        let item = this.allSermons[n + i];
        this.sermons.push(item);
      }
    },
    async getAllSermons() {      
      try {
        const url = this.$store.state.url + "api/lessons";
        const req = await fetch(url);
        this.allSermons = await req.json();                  
      } catch (error) {
        console.error(error);
      }
    },
    search() {
      if (this.searchText == "") {
        // this.sermons = [...this.allSermons];
        this.getData()
      } else {        
        const allSermons = [...this.allSermons]        
        this.sermons = allSermons.filter(
          (s) =>
            s.title.toLowerCase().includes(this.searchText.toLowerCase())  ||
            s.preacherName.toLowerCase().includes(this.searchText.toLowerCase())
        );        
      }
    },
  },
};
</script>

<style lang="css" scoped>
@media screen and (max-width: 600px) {
  .sermons-thumbnail {
    height: 250px !important;
  }
}

#search{background: url('~@/assets/search.svg'); background-size: 1rem; background-repeat: no-repeat; background-position: center right;}

.breadcumb-area.bg-img {
  background-image: url('../assets/slider/foundation.jpg');
  background-position-y: center;
}

</style>